import React, { useState, useEffect } from 'react';
import withAuth from './../../common/helper/auth-component.js';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import DashboardService from '../../../services/dashboard-service.js';
import PaymentMethodsService from '../../../services/payment-methods.service.js';
import LoaderOverlay from './../../common/helper/loader.component.js';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FundsService from '../../../services/funds-service.js';
import StatusBadge from '../../common/helper/transaction-status.component.js';
import { MESSAGES } from '../../constants/constants.js';


const AgentDashboard = () => { 
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const userData = useSelector(state => state.authReducer.user.data);
    const parts = userData.created_on.split(/[- :]/);
    const date = new Date(parts[2], parts[1] - 1, parts[0], parts[3], parts[4], parts[5]);
    const options = { day: '2-digit', month: 'long', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', options);
    const [transaction , setTransactionData] = useState();
    const [fundHistory , setFundHistory] = useState([]);
    const [transactionCount , setTransactionCount] = useState({});
    const [paymentMethodsData , setPaymentMethodsData] = useState({});

    const [transactionList , setTransactionList] = useState(([]));
    const [percentage , setMaxPercentage] = useState({percentage: '',type:''});

    const fetchData = async () => {
        try {
          setLoading(true);
          const [transactionSummary, transactionList, paymentMethods, fundsHistory,count] = await Promise.all([
            DashboardService.getTransactions(),
            DashboardService.getTransactionsList({},0,10),
            PaymentMethodsService.getPaymentMethods(),
            FundsService.fundHistory({},0,10),
            DashboardService.getCount()
          ]);
          setTransactionData(transactionSummary.data.data)
          setTransactionList(transactionList.data.data.list)
          setFundHistory(fundsHistory.data.data.list)
          setTransactionCount(count.data.data)
        

          const { maxAmount, maxAmountKey } = getMaxAmount(count.data.data);
          const keyDescription = getKeyDescription(maxAmountKey);
          setMaxPercentage({
            percentage : maxAmount,
            type : keyDescription
          })
          let paymentResponse = paymentMethods.data.data;
         
          let finalData = {}
        
          const qrStatus = paymentResponse.qr?.some(item => item.status_id === 'A');
          const walletStatus = paymentResponse.wallet?.some(item => item.status_id === 'A');
          const upiStatus = paymentResponse.upi?.some(item => item.status_id === 'A');
          if(qrStatus) {
            finalData['qrStatus'] = 'A'
          } else {
            finalData['qrStatus'] = 'S'
          }
          if(walletStatus) {
            finalData['walletStatus'] = 'A'
          } else {
            finalData['walletStatus'] = 'S'
          }
          if(upiStatus) {
            finalData['upiStatus'] = 'A'
          } else {
            finalData['upiStatus'] = 'S'
          }

          
          console.log(finalData)

          setPaymentMethodsData(finalData)
          setLoading(false);
        } catch (error) {
          console.log(error)
            try {
                const errorMessage = error.response.data
                toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
              } catch (e){
                toast.error( MESSAGES.SERVER_ERROR)
              }
          setLoading(false);
        }
      };
     const  viewProfile = () => {
        navigate(`/view-user/${userData.user_id}`)
     }
     const  viewTransactions = () => {
      navigate(`/transactions`)
   }

     const viewTransaction = (row) => {
      navigate(`/transaction/${row.transaction_id}`)
     }

     const formatDate = (dateString) => {
      const date = new Date(dateString);
      const options = { day: '2-digit', month: 'short' };
      return date.toLocaleDateString('en-US', options);
    };
    const viewPaymentMethods = () => {
      navigate(`/payment-methods`)
    }
    const fundListing = () => {
      navigate(`/funds-listing`)
    }
    const getKeyDescription = (key) => {
      // Return corresponding description based on key
      switch (key) {
          case 'wallet_count':
              return 'Wallet';
          case 'qr_count':
              return 'QR Code';
          case 'upi_count':
                return 'UPI';
          default:
              return '';
      }
  }
    const getMaxAmount = (data) => {

      let maxAmount = 0;
      let maxAmountKey = '';

      // Calculate total count
      const totalCount = Object.values(data).reduce((acc, curr) => acc + curr, 0);

      // Iterate through the data object to find the key with the maximum amount
      for (const key in data) {
          if (data.hasOwnProperty(key)) {
              const percentage = Math.round((data[key] * 100) / totalCount);
              if (percentage > maxAmount) {
                  maxAmount = percentage;
                  maxAmountKey = key;
              }
          }
      }

      return { maxAmount, maxAmountKey };
  }
  const walletPercentage = Math.round((transactionCount.wallet_count * 100) / Object.values(transactionCount).reduce((acc, curr) => acc + curr, 0));
const qrPercentage = Math.round((transactionCount.qr_count * 100) / Object.values(transactionCount).reduce((acc, curr) => acc + curr, 0));
const upiPercentage = Math.round((transactionCount.upi_count * 100) / Object.values(transactionCount).reduce((acc, curr) => acc + curr, 0));

    useEffect(() => {
        
        fetchData();
        document.body.style.backgroundImage = '';
      document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);
return(
    <>    <LoaderOverlay loading={loading} />
<div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
        <div>
          <div className>
            {/* start page title */}
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-3 font-size-18">Dashboard</h4>
                </div>
              </div>
            </div>
            {/* end page title */}
            <div className="row">
              <div className="col-xl-4">
                <div className="card overflow-hidden">
                  <div className="bg-primary-subtle">
                    <div className="row">
                      <div className="col-7">
                        <div className="text-primary p-3">
                          <h5 className="text-primary">Welcome Back !</h5>
                        </div>
                      </div>
                      <div className="col-5 align-self-end">
                        <img src="assets/profile-img.png" alt="" className="img-fluid" />
                      </div>
                    </div>
                  </div>
                  <div className="card-body pt-0">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="avatar-md profile-user-wid mb-3">
                          <img src="assets/images.png" alt="" className="img-thumbnail rounded-circle" />
                        </div>
                        <h5 className="font-size-15 text-truncate" style={{overflow: 'visible'}}>{userData.full_name}<i style={{float: 'right', marginTop: '3px', marginRight:'2px'}} className="fa fa-circle userfas" /></h5>
                        <p className="text-muted mb-0 text-truncate">{userData.agent_id}</p>
                      </div>
                      <div className="col-sm-12">
                        <div className="pt-3">
                          <div className="row">
                            <div className="col-5">
                              <p className="text-muted mb-0" style={{fontSize: '13px'}}>Phone</p>
                              <h5 style={{fontSize: '13px'}}>{userData.mobile_number}</h5>
                            </div>
                            <div className="col-7">
                              <p className="text-muted mb-0" style={{fontSize: '13px '}}>Email</p>
                              <h5  style={{fontSize: '13px'}}>{userData.email_address}</h5>
                            </div>
                          </div>
                          <div className="mt-2">
                            <a href="javascript: void(0);" className="btn btn-primary waves-effect waves-light btn-sm" onClick={() => viewProfile()}>View Profile <i className="fa fa-arrow-right ms-1" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header bg-transparent border-bottom" style={{paddingTop: '6px', paddingBottom: '8px'}}>
                    <div className="d-flex flex-wrap align-items-start">
                      <div className="me-2">
                        <h5 className="card-title mt-1 mb-0">Earning</h5>
                      </div>
                      <ul className="nav nav-tabs nav-tabs-custom card-header-tabs ms-auto" role="tablist" style={{borderBottom: '0px solid var(--bs-border-color)'}}>
                        <li className="nav-item" role="presentation">
                          <a className="nav-link active" style={{paddingTop: '2px', fontSize: '12px'}} data-bs-toggle="tab" href="#post-recent" role="tab" aria-selected="true"> Today </a>
                        </li>
                        <li className="nav-item" role="presentation">
                          <a className="nav-link" style={{paddingTop: '2px', fontSize: '12px'}} data-bs-toggle="tab" href="#post-recents" role="tab" aria-selected="false" tabIndex={-1}>Yesterday </a>
                        </li>
                        <li className="nav-item" role="presentation">
                          <a className="nav-link" style={{paddingTop: '2px', fontSize: '12px'}} data-bs-toggle="tab" href="#post-popular" role="tab" aria-selected="false" tabIndex={-1}> Weekly </a>
                        </li>
                        <li className="nav-item" role="presentation">
                          <a className="nav-link" style={{paddingTop: '2px', fontSize: '12px'}} data-bs-toggle="tab" href="#post-populars" role="tab" aria-selected="false" tabIndex={-1}> Monthly </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="card-body">
                    <div data-simplebar style={{maxHeight: '295px'}}>
                      {/* Tab panes */}
                      <div className="tab-content">
                        <div className="tab-pane active" id="post-recent" role="tabpanel">
                          <div className="row">
                            <div className="col-sm-6" style={{borderRight: '1px solid #f0f6fa'}}>
                              <p className="text-muted">Today Earning</p>
                              <h3  style={{fontSize:'14px'}}> ₹{ 
                                (transaction && transaction.amount_summary ? transaction.amount_summary.today_payin_amount : 0) +
                                (transaction && transaction.amount_summary ? transaction.amount_summary.today_payout_amount : 0)
                              }</h3>
                              <div className="mt-4">
                                <a href="javascript: void(0);" className="btn btn-primary waves-effect waves-light btn-sm" onClick={viewTransactions}>View More <i className="fa fa-arrow-right ms-1" />
                                </a>
                              </div>
                            </div>
                            <div className="col-sm-3">
                              <p className="text-muted">Payin</p>
                              <h4  style={{fontSize:'14px'}}>₹{(transaction && transaction.amount_summary ? transaction.amount_summary.today_payin_amount : 0) || 0}</h4>
                            </div>
                            <div className="col-sm-3">
                              <p className="text-muted">Payout</p>
                              <h4  style={{fontSize:'14px'}}>₹{(transaction && transaction.amount_summary ? transaction.amount_summary.today_payout_amount : 0) || 0}</h4>
                            </div>
                          </div>
                          <p className="text-muted mb-0 mt-2" style={{fontSize: '12px'}}>Simplify your earnings journey with seamless solution.</p>
                        </div>
                        <div className="tab-pane" id="post-recents" role="tabpanel">
                          <div className="row">
                            <div className="col-sm-6" style={{borderRight: '1px solid #f0f6fa'}}>
                              <p className="text-muted">Yesterday Earning</p>
                              <h3  style={{fontSize:'14px'}}>₹{ 
                                (transaction && transaction.amount_summary ? transaction.amount_summary.yesterday_payin_amount : 0) +
                                (transaction && transaction.amount_summary ? transaction.amount_summary.yesterday_payout_amount : 0)
                              }</h3>
                              <div className="mt-4">
                                <a href="javascript: void(0);" className="btn btn-primary waves-effect waves-light btn-sm" onClick={viewTransactions}>View More <i className="fa fa-arrow-right ms-1" />
                                </a>
                              </div>
                            </div>
                            <div className="col-sm-3">
                              <p className="text-muted">Payin</p>
                              <h4  style={{fontSize:'14px'}}>₹{(transaction && transaction.amount_summary ? transaction.amount_summary.yesterday_payin_amount : 0) || 0}</h4>
                            </div>
                            <div className="col-sm-3">
                              <p className="text-muted">Payout</p>
                              <h4  style={{fontSize:'14px'}}>₹{(transaction && transaction.amount_summary ? transaction.amount_summary.yesterday_payout_amount : 0) || 0}</h4>
                            </div>
                          </div>
                          <p className="text-muted mb-0 mt-2" style={{fontSize: '12px'}}>Simplify your earnings journey with seamless solution.</p>
                        </div>
                        {/* end tab pane */}
                        <div className="tab-pane" id="post-popular" role="tabpanel">
                          <div className="row">
                            <div className="col-sm-6" style={{borderRight: '1px solid #f0f6fa'}}>
                              <p className="text-muted">Weekly Earning</p>
                              <h3  style={{fontSize:'14px'}}>₹{ 
                                (transaction && transaction.amount_summary ? transaction.amount_summary.weekly_payin_amount : 0) +
                                (transaction && transaction.amount_summary ? transaction.amount_summary.weekly_payout_amount : 0)
                              }</h3>
                              <div className="mt-4">
                                <a href="javascript: void(0);" className="btn btn-primary waves-effect waves-light btn-sm" onClick={viewTransactions}>View More <i className="fa fa-arrow-right ms-1" />
                                </a>
                              </div>
                            </div>
                            <div className="col-sm-3">
                              <p className="text-muted">Payin</p>
                              <h4  style={{fontSize:'14px'}}>₹{(transaction && transaction.amount_summary ? transaction.amount_summary.weekly_payin_amount : 0) || 0}</h4>
                            </div>
                            <div className="col-sm-3">
                              <p className="text-muted">Payout</p>
                              <h4  style={{fontSize:'14px'}}>₹{(transaction && transaction.amount_summary ? transaction.amount_summary.weekly_payout_amount : 0)||0}</h4>
                            </div>
                          </div>
                          <p className="text-muted mb-0 mt-2" style={{fontSize: '12px'}}>Simplify your earnings journey with seamless solution.</p>
                        </div>
                        <div className="tab-pane" id="post-populars" role="tabpanel">
                          <div className="row">
                            <div className="col-sm-6" style={{borderRight: '1px solid #f0f6fa'}}>
                              <p className="text-muted">Monthly Earning</p>
                              <h3  style={{fontSize:'14px'}}>₹{ 
                                (transaction && transaction.amount_summary ? transaction.amount_summary.monthly_payin_amount : 0) +
                                (transaction && transaction.amount_summary ? transaction.amount_summary.monthly_payout_amount : 0)
                              }</h3>
                              <div className="mt-4">
                                <a href="javascript: void(0);" className="btn btn-primary waves-effect waves-light btn-sm" onClick={viewTransactions}>View More <i className="fa fa-arrow-right ms-1" />
                                </a>
                              </div>
                            </div>
                            <div className="col-sm-3">
                              <p className="text-muted">Payin</p>
                              <h4  style={{fontSize:'14px'}}>₹{(transaction && transaction.amount_summary ? transaction.amount_summary.monthly_payin_amount : 0) || 0}</h4>
                            </div>
                            <div className="col-sm-3">
                              <p className="text-muted">Payout</p>
                              <h4>₹{(transaction && transaction.amount_summary ? transaction.amount_summary.monthly_payout_amount : 0) || 0}</h4>
                            </div>
                          </div>
                          <p className="text-muted mb-0 mt-2" style={{fontSize: '12px'}}>Simplify your earnings journey with seamless solution.</p>
                        </div>
                        {/* end tab pane */}
                      </div>
                      {/* end tab content */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-8">
                <div className="row">
                  <div className="col-md-4">
                    <div className="card mini-stats-wid">
                      <div className="card-body">
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">Wallet Balance</p>
                            <h4 className="mb-0">₹{userData && userData.balances && userData.balances.pay_in_balance || 0}</h4>
                          </div>
                          <div className="flex-shrink-0 align-self-center">
                            <div className="mini-stat-icon avatar-sm rounded-circle bg-primary">
                              <span className="avatar-title">
                                <i className="bx bx-money font-size-24" />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card mini-stats-wid">
                      <div className="card-body">
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">Pending Balance</p>
                            <h4 className="mb-0">₹{userData && userData.balances && userData.balances.blocked_amount || 0}</h4>
                          </div>
                          <div className="flex-shrink-0 align-self-center">
                            <div className="avatar-sm rounded-circle bg-primary mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-primary">
                                <i className="fa fa-money font-size-19" style={{color: 'white'}} />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card mini-stats-wid">
                      <div className="card-body">
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">Member Since</p>
                            <h4 className="mb-0"> {formattedDate}</h4>
                          </div>
                          <div className="flex-shrink-0 align-self-center ">
                            <div className="avatar-sm rounded-circle bg-primary mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-primary">
                                <i className="bx bx-calendar font-size-24" />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* end row */}
                <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body" style={{padding: '15px 20px', height: '445.25px'}}>
                  <h4 className="card-title mb-2">Latest Transaction</h4>
                  <div className="table-responsive">
                    <table className="table align-middle table-nowrap mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="align-middle">Order ID</th>
                          <th className="align-middle">Payment Type</th>
                          <th className="align-middle">Date</th>
                          <th className="align-middle">Amount</th>
                          <th className="align-middle">Status</th>
                          <th className="align-middle">Payment Method</th>
                          <th className="align-middle">View</th>
                        </tr>
                      </thead>
                      <tbody>
                      {transactionList.slice(0, 8).map((transaction, index) => ( 
                        <tr>
                          <td>
                            <a href="#" className="text-body fw-bold">{transaction.order_code}</a>
                          </td>
                          <td style={{ color: transaction.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }}><i className="fa fa-money me-1" style={{ color: transaction.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }} /> {transaction.transaction_type.toLowerCase().charAt(0).toUpperCase() + transaction.transaction_type.toLowerCase().slice(1)}</td>
                          <td>{transaction.start_date}</td>
                          <td> ₹{transaction.amount} </td>
                          <td>
                          
                          <StatusBadge status={transaction.status} />

                            
                          </td>
                          <td>
                            <i className={`fa  me-1 ${
                               transaction.payment_method && transaction.payment_method?.toLowerCase() === 'imps' ? 'fa-money' :
                            transaction.payment_method && transaction.payment_method.toLowerCase() === 'wallet' ? 'fa-credit-card' :
                            transaction.payment_method && transaction.payment_method.toLowerCase() === 'upi' ? 'fa-google-wallet' :
                            transaction.payment_method && transaction.payment_method.toLowerCase() === 'qr' ? 'fa-qrcode ' :
                            ''}`} /> {transaction.payment_method || '-'}
                          </td>
                          <td>
                            {/* Button trigger modal */}
                            <a style={{cursor:'pointer'}}><i className="fa fa-eye" style={{fontSize: '16px', color: '#3280dd !important'}} onClick={() => viewTransaction(transaction)}/></a>
                          </td>
                        </tr>

                       ))}
                     
                      </tbody>
                    </table>
                    {transactionList.length == 0 && (
                          <div className='no-transaction'><b>No Transaction found.</b></div>
                      )} 
                  </div>
                  {/* end table-responsive */}
                </div>
              </div>
            </div>
          </div>
              </div>
            </div>
            {/* end row */}
            <div className="row">
              <div className="col-xl-4">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title mb-4">Payment Methods</h4>
                    <div className="row mt-4">
                      <div className="row mt-4">
                        <div className="col-12">
                          <div className="row social-source text-left mt-2">
                            <div id="wrapper"><span className="label">Methods</span>
                              <div className="branch lv1">
                              <div className="entry"><span className="label">Wallet</span>
                                  <span className="switch1">

                                    {paymentMethodsData && paymentMethodsData.walletStatus == 'S' && (
                                      <>
                                       <input disabled id="switch-disabled" type="checkbox" />
                                       <label htmlFor="switch-disabled" />
                                      </>
                                    )} 
                                    {paymentMethodsData && paymentMethodsData.walletStatus != 'S' && (
                                      <>
                                     <input disabled id="switch-rounded" type="checkbox" defaultChecked />
                                    <label htmlFor="switch-rounded" />
                                      </>
                                    )} 
                                   
                                  </span>
                                </div>
                                <div className="entry"><span className="label">UPI</span><span className="switch1">
                                {paymentMethodsData && paymentMethodsData.upiStatus == 'S' && (
                                      <>
                                       <input disabled id="switch-disabled" type="checkbox" />
                                       <label htmlFor="switch-disabled" />
                                      </>
                                    )} 
                                    {paymentMethodsData && paymentMethodsData.upiStatus != 'S' && (
                                      <>
                                     <input disabled id="switch-rounded" type="checkbox" defaultChecked />
                                    <label htmlFor="switch-rounded" />
                                      </>
                                    )} 
                                  </span></div>
                                <div className="entry"><span className="label">QR Code</span>
                                  <span className="switch1">
                                  {paymentMethodsData && paymentMethodsData.qrStatus == 'S' && (
                                      <>
                                       <input disabled id="switch-disabled" type="checkbox" />
                                       <label htmlFor="switch-disabled" />
                                      </>
                                    )} 
                                    {paymentMethodsData && paymentMethodsData.qrStatus != 'S' && (
                                      <>
                                     <input disabled id="switch-rounded" type="checkbox" defaultChecked />
                                    <label htmlFor="switch-rounded" />
                                      </>
                                    )} 
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-12 mt-4 mb-3" style={{textAlign: 'left', marginTop: '3px', marginBottom: '15px'}}>
                              <a href="javascript: void(0);" className="btn btn-primary waves-effect waves-light btn-sm" onClick={viewPaymentMethods}>View Payment Method <i className="fa fa-arrow-right ms-1" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4">
                <div className="card">
                  <div className="card-body" style={{height: '379.09px'}}>
                    <h4 className="card-title mb-4">Fund Transfer</h4>
                    <ul className="verti-timeline list-unstyled">
                    {fundHistory && fundHistory.slice(0, 5).map((fund, index) => ( 

                      <li className="event-list active">
                        <div className="event-timeline-dot">
                          <i className="bx bxs-right-arrow-circle font-size-18 " />
                        </div>
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <h5 className="mt-0 font-size-14">{formatDate(fund.transfer_date)}<i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                            </h5>
                          </div>
                          <div>
                          {fund.transfer_type === 'DEPOSIT' ? (
                            <> 
                              Payin request for ₹{fund.transfer_amount}
                            </>
                          ) : (
                            <> 
                              Payout request for ₹{fund.transfer_amount}
                            </>
                          )}
                        </div>
                        </div>
                      </li>

                ))}
                {fundHistory.length == 0 && (
 <div style = {{paddingTop: '117px'}} className='no-transaction'><b>No Fund transfer found.</b></div>                      )} 
                      {/* <li className="event-list">
                        <div className="event-timeline-dot">
                          <i className="bx bx-right-arrow-circle font-size-18" />
                        </div>
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <h5 className="mt-0 font-size-14">17 Nov <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                            </h5>
                          </div>
                          <div className="flex-grow-1">
                            <div> Payout request for ₹125.5
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="event-list">
                        <div className="event-timeline-dot">
                          <i className="bx bx-right-arrow-circle font-size-18" />
                        </div>
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <h5 className="mt-0 font-size-14">17 Nov <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                            </h5>
                          </div>
                          <div className="flex-grow-1">
                            <div> Payout request for ₹125.5
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="event-list">
                        <div className="event-timeline-dot">
                          <i className="bx bx-right-arrow-circle font-size-18" />
                        </div>
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <h5 className="mt-0 font-size-14">10 Nov <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                            </h5>
                          </div>
                          <div className="flex-grow-1">
                            <div> Payout request for ₹125.5
                            </div>
                          </div>
                        </div>
                      </li> */}
                    </ul>
                    {fundHistory.length > 5 && (
                    <div className="text-left mt-5">
                      <a href="javascript: void(0);" className="btn btn-primary waves-effect waves-light btn-sm" onClick={fundListing}>View More <i className="fa fa-arrow-right ms-1" />
                      </a>
                    </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-xl-4">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title mb-4">Payment Analytics</h4>
                    <div className="text-center">
                      <div className="mb-3">
                        <i className="fa fa-spinner fa-spin text-primary display-3" style={{fontSize: '3rem'}} />
                      </div>
                      <h3>{percentage.percentage}%</h3>
                      <p style={{marginBottom: '-2px'}}>{percentage.type}</p>
                    </div>
                    <div className="table-responsive mt-4">
                    <table className="table align-middle table-nowrap">
                        <tbody>
                          <tr>
                            <td style={{width: '30%'}}>
                              <p className="mb-0">Wallet</p>
                            </td>
                            <td style={{width: '25%'}}>
                              <h5 className="mb-0 mt-0">{transactionCount.wallet_count}</h5>
                            </td>
                            <td>
                              <div className="mb-0 progress bg-transparent progress-sm">
                              <div className="progress-bar bg-primary rounded" role="progressbar" style={{ width: `${walletPercentage}%` }} aria-valuenow={walletPercentage} aria-valuemin={0} aria-valuemax={100} />

                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p className="mb-0">UPI</p>
                            </td>
                            <td>
                              <h5 className="mb-0 mt-0">{transactionCount.upi_count}</h5>
                            </td>
                            <td>
                              <div className="mb-0 progress bg-transparent progress-sm">
                              <div className="progress-bar bg-primary rounded" role="progressbar" style={{ width: `${upiPercentage}%` }} aria-valuenow={upiPercentage} aria-valuemin={0} aria-valuemax={100} />

                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p className="mb-0">QR Code</p>
                            </td>
                            <td>
                              <h5 className="mb-0 mt-0">{transactionCount.qr_count}</h5>
                            </td>
                            <td>
                              <div className="mb-0 progress bg-transparent progress-sm">
                              <div className="progress-bar bg-primary rounded" role="progressbar" style={{ width: `${qrPercentage}%` }} aria-valuenow={upiPercentage} aria-valuemin={0} aria-valuemax={100} />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p className="mb-0" style={{fontWeight: 700}}>*Last Today details</p>
                  </div>
                </div>
              </div>s
            </div>
            {/* end row */}
            {/* end row */}
          </div>
        </div>
      </div>
</> 
)

}
function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(AgentDashboard));